export const problemComplexities = [
  "find_clauses",
  "summary",
  "bounded",
  "remediation",
];
export type ProblemComplexityKey = typeof problemComplexities[number];

export type ProblemComplexity = {
  [K in ProblemComplexityKey]?: {
    keys: string[];
    extends?: ProblemComplexityKey;
  };
};

export type ScoredProblemComplexity = Partial<
  Record<ProblemComplexityKey, number>
> & {all: number};
export interface QueryDomain {
  problem_complexity: ProblemComplexity;
  question_complexity: {
    multi_clause: boolean;
    together: boolean;
    complex_definitions: boolean;
  };
  adhoc: boolean;
  scope: "single_document" | "multi_document";
  domain: "nda" | "commercial" | "real_estate" | "finance";
}

export function isQueryDomain(obj: unknown): boolean {
  if (!obj || typeof obj !== "object") {
    return false;
  }
  const domain = obj as QueryDomain;
  if (
    !domain.problem_complexity ||
    typeof domain.problem_complexity !== "object"
  ) {
    return false;
  } else {
    for (const key of problemComplexities) {
      if (
        domain.problem_complexity[key] &&
        typeof domain.problem_complexity[key] !== "object"
      ) {
        return false;
      } else {
        const complexity = domain.problem_complexity[key];
        if (
          complexity &&
          complexity.extends &&
          !problemComplexities.includes(complexity.extends)
        ) {
          return false;
        }
        if (
          complexity &&
          complexity.keys &&
          (!Array.isArray(complexity.keys) ||
            complexity.keys.some(cKey => typeof cKey !== "string"))
        ) {
          return false;
        }
      }
    }
  }
  if (
    !domain.question_complexity ||
    typeof domain.question_complexity !== "object"
  ) {
    return false;
  }
  if (typeof domain.adhoc !== "boolean") {
    return false;
  }
  if (domain.scope !== "single_document" && domain.scope !== "multi_document") {
    return false;
  }
  if (
    domain.domain !== "nda" &&
    domain.domain !== "commercial" &&
    domain.domain !== "real_estate" &&
    domain.domain !== "finance"
  ) {
    return false;
  }
  return true;
}
